<template>
  <div class="service" :class="{ customer: data.type === 'customer' }">
    <div class="service-left">
      <img :src="data.avatarUrl" />
    </div>
    <div class="service-right">
      <h6 class="service-personnel van-ellipsis">{{ data.title }}</h6>
      <p class="service-info" v-html="data.content"></p>
      <p
        v-if="data.type === 'teacher'"
        class="btn-copy"
        data-clipboard-text="zhuokao129"
      >
        点击复制微信号
      </p>
    </div>
  </div>
</template>

<script>
  import Clipboard from 'clipboard';

  export default {
    name: 'message',
    props: {
      type: String,
      data: Object,
    },
    created() {
      const clipboard = new Clipboard('.btn-copy');
      clipboard.on('success', () => {
        this.$toast('复制成功');
      });
    },
  };
</script>

<style lang="scss" scoped>
.service {
  display: flex;
  margin-bottom: 15px;
  white-space: nowrap;
}

.customer.service {
  flex-direction: row-reverse;
}

.service-left > img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.service-right {
  flex: 1;
  margin: 0 8px;
  padding-right: 50px;
}

.customer .service-right {
  padding: 0 0 0 50px;
  text-align: right;
}

.service-personnel {
  margin-bottom: 10px;
  font-size: 12px;
  color: #62778c;
}

.customer .service-personnel {
  display: none;
}

.service-info {
  display: inline-block;
  padding: 10px 8px;
  font-size: 13px;
  color: #28334b;
  line-height: 20px;
  word-break: break-word;
  white-space: normal;
  background-color: #eff3f6;
  border-radius: 8px;
}

.customer .service-info {
  color: #fff;
  background-color: #1f8ce8;
}

.btn-copy {
  position: relative;
  top: 8px;
}
</style>
